Ext.define('SA.VectorMapExportInsetMap', {
    alias: 'widget.vector-map-export-inset-map',
    extend: 'SA.VectorMapExportScalingContainer',

    item: {
        xtype: 'component',
        childEls: ['container', 'extentCanvas'],
        width: 160,

        renderTpl: [
            '<div id="{id}-container" class="sa-vector-map-export-inset-map-container"></div>',
            '<canvas id="{id}-extentCanvas" class="sa-vector-map-export-inset-map-extent-canvas"></canvas>'
        ]
    },

    statics: {
        getCanvas({maxExtent, params, scale, style}) {
            return new Promise(resolve => {
                var el = SA.HiddenDom.attach(SA.Html.create({type: 'div'})),
                    map = Ext.widget({xtype: 'vector-map-export-inset-map', maxExtent, renderTo: el, scale, style});

                map.setParams(params);

                map.map.once('idle', () => {
                    resolve(new SA.CanvasRenderer().render({
                        width: map.map.getCanvas().width,
                        height: map.map.getCanvas().height,

                        content: [
                            {type: 'image', source: map.map.getCanvas()},
                            {type :'image', source: map.item.extentCanvas.dom}
                        ]
                    }).getCanvas());

                    map.destroy();
                    el.remove();
                });
            });
        }
    },

    afterRender() {
        var {maxExtent, style} = this;

        this.callParent();

        this.map = new maplibregl.Map({
            container: this.item.container.dom,
            interactive: false,
            maxBounds: maxExtent.toLngLatBounds(),
            preserveDrawingBuffer: true,
            style,
            trackResize: false
        });

        this.extentRenderer = new SA.CanvasRenderer(this.item.extentCanvas.dom);

        this.loading = false;

        this.map.on('data', this.onMapData.bind(this));
        this.map.on('dataabort', this.onMapData.bind(this));
        this.map.on('dataloading', this.onMapData.bind(this));
    },

    destroy() {
        this.map?.remove();

        this.callParent();
    },

    isLoading() {
        return this.loading;
    },

    onLoadingChange(callback, scope) {
        this.on('change:loading', callback, scope);
    },

    onMapData() {
        var loading = !this.map.isStyleLoaded();

        if (loading !== this.loading) {
            this.loading = loading;

            this.fireEvent('change:loading');
        }
    },

    refreshExtentRectangle(extent) {
        var {x: left, y: bottom} = this.map.project(extent.getSouthWest().toLngLat()),
            {x: right, y: top} = this.map.project(extent.getNorthEast().toLngLat()),
            x = left * this.map.getPixelRatio(),
            y = top * this.map.getPixelRatio(),
            width = (right - left) * this.map.getPixelRatio(),
            height = (bottom - top) * this.map.getPixelRatio();

        this.extentRenderer.render({
            width: this.map.getCanvas().width,
            height: this.map.getCanvas().height,

            content: {
                type: 'rect',
                fill: 'rgba(255, 120, 0, 0.2)',
                stroke: 'rgba(255, 120, 0, 0.5)',
                x, y, width, height
            }
        });
    },

    setParams({extent, height, width}) {
        this.setSize(width, height);

        this.item.setHeight(this.item.getEl().dom.offsetWidth / extent.getAspectRatio());

        this.map.setPixelRatio(Math.max(this.getScale(), devicePixelRatio));
        this.map.resize();
        this.map.fitBounds(extent.scale(this.scale).toLngLatBounds(), {animate: false});

        this.refreshExtentRectangle(extent);
    }
});